import { gql } from 'graphql-request';

export const CASTING_PROJECT_LIST = gql`
  query ($first: Int, $after: String, $search: String, $archived: Boolean) {
    agency_casting_projects(first: $first, after: $after, search: $search, archived: $archived) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        name
        company {
          id
          name
        }
      }
    }
  }
`;

export const AGENCY_CASTING_COMPANIES = gql`
  query ($first: Int, $after: String, $name: String) {
    agency_casting_companies_connection(first: $first, after: $after, name: $name) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        name
      }
    }
  }
`;

export const CASTING_COMPANIES = gql`
  query ($first: Int, $after: String, $name: String, $country: [String!]) {
    casting_companies_connection(first: $first, after: $after, name: $name, country: $country) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      nodes {
        id
        name
        country
      }
    }
  }
`;
